import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { NgxSpinnerService } from 'ngx-spinner';
import { ProdutoDesconto } from 'src/app/models/produto';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';
import swal from 'sweetalert2';

@Component({
  selector: 'app-cadastrar-desconto-produto',
  templateUrl: './cadastrar-desconto-produto.component.html',
  styleUrls: ['./cadastrar-desconto-produto.component.scss']
})
export class CadastrarDescontoProdutoComponent implements OnInit {

  produtoDesconto: ProdutoDesconto;
  valorTotal = 0;
  tipoTexto = undefined;
  descontos: ProdutoDesconto[] = [];
  public config: PerfectScrollbarConfigInterface = {};
  podeLote = false;


  // construtor
  constructor(public dialogRef: MatDialogRef<CadastrarDescontoProdutoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private notificacaoService: NotificacaoService,
    private spinner: NgxSpinnerService, private utilitarioService: UtilitarioService) { }

  ngOnInit() {
    this.podeLote = this.data.podeLote;
    this.produtoDesconto = this.data.produtoDesconto;
    this.descontos = this.data.descontos;
    // this.valorTotal = this.data.valorTotal;
    // this.produtoDesconto.valor = this.utilitarioService.formataNumero(this.produtoDesconto.valor);
  }

  salvar() {

    this.produtoDesconto.descoCusto = 0;

    if ((this.produtoDesconto.emLote &&
      (Number(this.produtoDesconto.descontoInicial) > 100 ||
        Number(this.produtoDesconto.descontoInicialCusto) > 100 ||
        Number(this.produtoDesconto.descontoFinal) > 100 ||
        Number(this.produtoDesconto.descontoFinalCusto) > 100)) ||
      (!this.produtoDesconto.emLote && (Number(this.produtoDesconto.desco) > 100 || Number(this.produtoDesconto.descoCusto) > 100))) {
      swal({
        title: 'O valor do percentual de desconto deve ser menor ou igual a 100!!!',
        text: '',
        buttonsStyling: false,
        confirmButtonClass: 'btn btn-warning',
        type: 'warning'
      }).catch(swal.noop);
    } else if (Number(this.produtoDesconto.qtdIni) > Number(this.produtoDesconto.qtdFim)) {
      swal({
        title: 'O valor da quantidade inicial deve ser menor do que o valor quantidade final!',
        text: '',
        buttonsStyling: false,
        confirmButtonClass: 'btn btn-warning',
        type: 'warning'
      }).catch(swal.noop);
    } else if (this.descontos.some(p => p.situacao !== 2 && (
      (Number(this.produtoDesconto.qtdIni) <= Number(p.qtdIni) && Number(this.produtoDesconto.qtdFim) >= Number(p.qtdIni) && Number(this.produtoDesconto.qtdFim) <= Number(p.qtdFim)) ||
      (Number(this.produtoDesconto.qtdIni) <= Number(p.qtdIni) && Number(this.produtoDesconto.qtdFim) >= Number(p.qtdFim)) ||
      (Number(this.produtoDesconto.qtdIni) >= Number(p.qtdIni) && Number(this.produtoDesconto.qtdIni) <= Number(p.qtdFim) && Number(this.produtoDesconto.qtdFim) <= Number(p.qtdFim)) ||
      (Number(this.produtoDesconto.qtdIni) >= Number(p.qtdIni) && Number(this.produtoDesconto.qtdIni) <= Number(p.qtdFim) && Number(this.produtoDesconto.qtdFim) >= Number(p.qtdFim))))) {
      swal({
        title: 'Já existem descontos dentro da mesma faixa de quantidades!',
        text: 'Deseja substituí-los?',
        showCancelButton: true,
        confirmButtonClass: 'btn btn-info',
        cancelButtonClass: 'btn btn-danger',
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
        buttonsStyling: false,
        type: 'warning'
      }).then((result) => {
        if (result.value) {
          this.descontos.filter(p => p.situacao !== 2 && (
            (Number(this.produtoDesconto.qtdIni) <= Number(p.qtdIni) && Number(this.produtoDesconto.qtdFim) >= Number(p.qtdIni) && Number(this.produtoDesconto.qtdFim) <= Number(p.qtdFim)) ||
            (Number(this.produtoDesconto.qtdIni) <= Number(p.qtdIni) && Number(this.produtoDesconto.qtdFim) >= Number(p.qtdFim)) ||
            (Number(this.produtoDesconto.qtdIni) >= Number(p.qtdIni) && Number(this.produtoDesconto.qtdIni) <= Number(p.qtdFim) && Number(this.produtoDesconto.qtdFim) <= Number(p.qtdFim)) ||
            (Number(this.produtoDesconto.qtdIni) >= Number(p.qtdIni) && Number(this.produtoDesconto.qtdIni) <= Number(p.qtdFim) && Number(this.produtoDesconto.qtdFim) >= Number(p.qtdFim)))).forEach(p => { p.situacao = 2; });

          this.dialogRef.close(this.produtoDesconto);
        }
      });
    } else {
      this.dialogRef.close(this.produtoDesconto);
    }
  }

  fechar() {
    this.dialogRef.close();
  }
}
